/**
 * Converts an `<input type="month">` value to the last calendar day of that month.
 * Documents are stored against a month-end `period_end`, so the two must agree
 * exactly for filtering to work.
 *
 * @example monthEndDate('2026-07') // '2026-07-31'
 */
export const monthEndDate = (yearMonth: string): string => {
    if (!yearMonth) return '';
    const [year, month] = yearMonth.split('-').map(Number);
    // Day 0 of the next month is the last day of this one.
    const lastDay = new Date(year, month, 0).getDate();
    return `${yearMonth}-${String(lastDay).padStart(2, '0')}`;
};

/**
 * The previous calendar month, as an `<input type="month">` value.
 *
 * @example // run during Jan 2026 → '2025-12'
 */
export const previousMonthValue = (): string => {
    const today = new Date();
    // Day 0 of this month is the last day of the previous one, so January rolls
    // back the year without a special case.
    const previous = new Date(today.getFullYear(), today.getMonth(), 0);
    return `${previous.getFullYear()}-${String(previous.getMonth() + 1).padStart(2, '0')}`;
};
